import { Contact } from '@/core/domain/people/_shared/Contact';

export default function flatContacts(contacts?: Contact[]) {
  return contacts?.map((contact) => contact.detailList).flat() || [];
}
